import Task from "../../../../model2/task/task"
import {ProjectAccess} from "../../../../gd/const/project"
import CompanyUser from "../../../../model2/company-user-new/company-user"
import UserToAdd from "../add-user"
import {getAllProjectIds, getAllWorkspaceProjectIds, getUsersOnAllTasks} from "./helpers"


// Company users that are missing from at least one of the workspaces the
// selected tasks belong to (or, if no workspaces are involved, missing from
// at least one sub-project). Picking such a user needs workspace + project +
// task adds.
export function bulkComputeCompanyUsers(tasks: Task[], taskUserIdsByTaskId: Map<ID, ID[]>): UserToAdd[] {
    const allWorkspaceProjectIds = getAllWorkspaceProjectIds(tasks)
    const allProjectIds          = getAllProjectIds(tasks)
    const onAllTasks             = getUsersOnAllTasks(tasks, taskUserIdsByTaskId)
    const hasWorkspaces          = allWorkspaceProjectIds.length > 0

    const models : UserToAdd[] = []

    _.each(gd.session.companyUsers.notClients(), (companyUser: CompanyUser) => {
        const userId = companyUser.userId

        if (onAllTasks.has(userId)) return

        const inAllProjects = _.every(allProjectIds, (projectId: ID) => {
            const project = gd.session.projects.get(projectId)
            return !!project && project.userIds().includes(userId)
        })
        if (inAllProjects) return // belongs to projectUsersToAdd

        if (hasWorkspaces) {
            const inAllWorkspaces = _.every(allWorkspaceProjectIds, (wpId: ID) => {
                const ws = gd.session.projects.get(wpId)
                return !!ws && ws.userIds().includes(userId)
            })
            if (inAllWorkspaces) return // belongs to workspaceUsersToAdd
        }

        const userToAdd = new UserToAdd(companyUser)
        userToAdd.workspaceAccess = ProjectAccess.STANDARD
        userToAdd.projectAccess   = ProjectAccess.STANDARD
        models.push(userToAdd)
    })

    return models
}
